import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/i18n";

const LanguageContext = createContext(null);

export const useLang = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("asa-lang") || "es");

    useEffect(() => {
        localStorage.setItem("asa-lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (path) => path.split(".").reduce((o, k) => o?.[k], dict[lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}
